import { render } from "./a-resize-handle.vue?vue&type=template&id=b6dde214&scoped=true"
import script from "./a-resize-handle.vue?vue&type=script&lang=js"
export * from "./a-resize-handle.vue?vue&type=script&lang=js"

import "./a-resize-handle.vue?vue&type=style&index=0&id=b6dde214&scoped=true&lang=sass"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6dde214"]])

export default __exports__